import { createPaginator } from "@smithy/core";
import { ListProjectPoliciesCommand, } from "../commands/ListProjectPoliciesCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListProjectPolicies = createPaginator(RekognitionClient, ListProjectPoliciesCommand, "NextToken", "NextToken", "MaxResults");
